import * as ActionTypes from "constants/ActionTypes";

export default function keysDown(state = [], action) {
  switch (action.type) {
    case ActionTypes.KEY_DOWN:
      return [...state, action.key];
    case ActionTypes.KEY_UP: {
      const actionKey = action.key;
      return state.filter((key) => key !== actionKey);
    }
    default:
      return state;
  }
}
